import { Instagram } from "lucide-react";
import { Reveal } from "./Reveal";
import { EMAIL, CITY, telLink, INSTAGRAM_URL, INSTAGRAM_HANDLE } from "@/config";

export const Footer = () => (
  <footer className="bg-brandDarkSlate text-brandCream/70 py-16 text-center text-sm">
    <Reveal className="max-w-6xl mx-auto px-4 flex flex-col items-center gap-5">
      <img
        data-testid="footer-emblem"
        src="/images/emblem.webp"
        alt="Enchanted Glim gold emblem"
        className="w-24 h-24 rounded-2xl object-cover shadow-lg shadow-black/30"
      />
      <p className="font-serif italic font-semibold text-xl text-brandCream">Handcrafted with care for your health and home.</p>
      <div className="flex flex-col items-center gap-2">
        <p data-testid="footer-owner" className="text-xs uppercase tracking-[0.25em] text-brandCream/60">
          Founded &amp; hand-poured by
        </p>
        <p
          data-testid="footer-founder-name"
          className="font-serif text-4xl sm:text-5xl font-bold uppercase tracking-[0.12em] bg-gradient-to-b from-amber-200 via-[#E5C15D] to-amber-600 bg-clip-text text-transparent [filter:drop-shadow(0_1px_0_rgba(255,240,200,0.35))_drop-shadow(0_-1px_1px_rgba(0,0,0,0.65))]"
        >
          Bhavani
        </p>
      </div>
      <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-6 text-xs tracking-wide">
        <a data-testid="footer-email" href={`mailto:${EMAIL}`} className="hover:text-brandTerracotta transition-colors">
          {EMAIL}
        </a>
        <span aria-hidden className="hidden sm:inline text-brandCream/30">
          ·
        </span>
        <a data-testid="footer-phone" href={telLink} className="hover:text-brandTerracotta transition-colors">
          +91 91801 80056
        </a>
        <span aria-hidden className="hidden sm:inline text-brandCream/30">
          ·
        </span>
        <span>{CITY}</span>
        <span aria-hidden className="hidden sm:inline text-brandCream/30">
          ·
        </span>
        <a
          data-testid="footer-instagram"
          href={INSTAGRAM_URL}
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center gap-1.5 hover:text-brandTerracotta transition-colors"
        >
          <Instagram className="w-3.5 h-3.5" />
          {INSTAGRAM_HANDLE}
        </a>
      </div>
      <p className="text-xs tracking-wide text-brandCream/50">© 2026 Enchanted Glim. All rights reserved.</p>
    </Reveal>
  </footer>
);
